import { defineMessages, IntlProvider } from 'react-intl';

import Agent from './data-sources/Agent';
import CallQueue from './data-sources/CallQueue';
import Chart from '../models/Chart';
import ChartOption from '../models/ChartOption';
import Queued from './data-sources/Queued';

const messages = defineMessages({
  AGGREGATED: {
    id: 'AGGREGATED',
    defaultMessage: 'Aggregate',
  },
  PER_AGENT: {
    id: 'PER_AGENT',
    defaultMessage: 'Per Agent',
  },
  PER_QUEUE: {
    id: 'PER_QUEUE',
    defaultMessage: 'Per Queue',
  },
});

/**
 * Returns gauge chart manifest
 * @param locale
 * @returns {Chart}
 */
// eslint-disable-next-line import/prefer-default-export
export const initResponsiveTable = (locale = 'en_us') => {
  const { intl } = new IntlProvider({
    locale,
    messages,
  }, {}).getChildContext();

  /**
   * default values for required query parameters
   * @type {{time_range: string}}
   */
  const queryParams = {
    time_range: '1_day',
  };

  /**
   * Displays chart options to the user
   * type: timeRange displays an input and sets the start/end for the api request
   * type: queueFilter displays an input and sets the queue/s for the api request
   */
  const chartOptions = [
    new ChartOption({ type: 'queueFilter', required: false }),
  ];

  const agent = new Agent(intl);
  const callQueue = new CallQueue(intl);
  const queued = new Queued(intl);

  return new Chart({
    type: 'ResponsiveTable',
    chartOptions,
    queryParams,
    dataOptions: {
      Agent: agent.dataOptions,
      Callqueue: callQueue.dataOptions,
      Queued: queued.dataOptions,
    },
    usesColumns: true,
    usesTimeRange: true,
    alertSupport: true,
  });
};
